/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const hera: CommunityData = {
  code: "hera",
  inviteCode: "hera",
  name: "Hera",
  thumbnail: "/assets/customizations/hera/hera-thumbnail.png",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/her-155`,
  socials: {
    instagramLink: "https://www.instagram.com/herasthlm/",
    soundcloudLink: "",
  },
  styles: {
    global: {
      counterColor: "#3C404B",
      alternativeLogo: {
        src: "/assets/customizations/hera/white-logo.svg",
        styles: "w-[144px]",
      },
      logo: {
        src: "/assets/customizations/hera/logo.svg",
        styles: "w-[262px] h-10",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#E80048",
      asideStyles: "",
      asideBg: "#E16F8E",
      contentBg:
        "linear-gradient(0deg,#FFFFFF,#FFFFFF),linear-gradient(0deg,#EF95AE,#EF95AE),#D44E73",
      contentBoxShadow: "shadow-[0px_4px_40px_rgba(0,0,0,0.25)]",
      bgDesktop: "/assets/customizations/hera/hera-bg.png",
      bgMobile: "/assets/customizations/hera/hera-bg.png",
      mainFont: "font-['Antonio']",
      primaryButton:
        "w-full sm:w-fit !h-[55px] bg-[#3C404B] !px-[30px] !text-[18px] !leading-[1] font-['Antonio'] !font-bold !text-white whitespace-nowrap uppercase",
    },
    navigation: {
      sideBarSeparator: "",
      iconsColor: "#ffffff",
      separator: "border-[#F39BB3] border-t",
      item: "font-['Antonio'] text-[18px] leading-[18px] h-[40px] flex items-center sm:justify-start justify-center uppercase text-white font-bold ",
      itemSelected: "bg-[#CF5C7C] text-white",
    },
    communityLanding: {
      emptyOrLoadingState: "",
      titles: "font-['Antonio'] uppercase text-[#3C404B] text-[24px] font-bold leading-[24px] pb-2",
      announcements: {
        customBg: "bg-white",
        lg: {
          title: "text-[20px] sm:text-[24px] leading-8 font-bold mb-1",
          subtitle: "text-[11px] leading-[1] text-[#FEA349]",
        },
        sm: {
          title: "text-[20px] sm:text-base leading-8 sm:leading-5 mb-2",
          subtitle: "text-[11px] leading-[1] text-[#FEA349]",
        },
      },
      event: {
        title: "text-base leading-[0.8] sm:leading-[1] text-[#3C404B]",
        subtitle: "text-[14px] leading-[18px] text-[#3C404B] !font-normal",
      },
      shop: {
        title: "text-[20px] leading-[1] font-bold font-['Antonio'] text-[#3C404B] uppercase",
        text: "text-[14px] leading-[18px] text-[#3C404B] font-['Archivo']",
        customShopImage: "/assets/customizations/hera/img_shop.png",
      },
    },
    announcements: {
      emptyOrLoadingState: "",
      created: "",
      container: "mb-16 p-11 pb-8 space-y-[57px]",
      header: "font-['Antonio'] uppercase text-[#3C404B] text-[32px] font-bold leading-[32px]",
      title: "font-['Antonio'] uppercase text-[#3C404B] text-[24px] font-bold leading-[24px] pb-2",
      description: "text-[11px] leading-[1] font-semibold !text-[#FEA349]",
    },
    announcement: {
      likeCount: "",
      commentCount: "",
      emptyOrLoadingState: "",
      created: "",
      container: "mb-16 p-11 pb-8 space-y-[23px]",
      title: "font-['Antonio'] uppercase text-[#3C404B] text-[24px] font-bold leading-[24px] pb-2",
      description: "text-[11px] leading-[1] font-semibold !text-[#FEA349]",
      commentIconColor: "",
      likeIconColor: "",
    },
    event: {
      emptyOrLoadingState: "",
      sectionTitle: "text-[32px] font-bold leading-10 font-['Antonio'] text-[#3C404B] uppercase",
      sectionSubtitle: "text-[14px] leading-[18px] font-semibold text-[#3C404B] font-['Archivo']",
      text: "text-[14px] leading-[18px] text-[#3C404B] font-['Archivo']",
      separator: "border-b border-[#3C404B] border-opacity-40",
      blockContainer: "",
      header: "",
      container: "",
      map: {
        pin: "",
        border: "",
        pinColor: "#E80048",
        strokeColor: "border-[#E80048]",
      },
    },
    eventTickets: {
      container: "",
      separator: "",
      event: {
        title: "text-[32px] font-bold leading-10 font-['Antonio'] text-[#3C404B] uppercase",
        subtitle: "text-[16px] leading-[18px] font-medium text-[#3C404B]",
      },
      ticket: {
        counterContainer: "",
        title: "text-[24px] uppercase leading-7 font-['Antonio'] font-bold text-[#3C404B]",
        description: "text-base leading-4 font-bold",
        text: "text-[14px] leading-[18px] text-[#3C404B]",
        price: "text-[24px] leading-7 text-[#3C404B]",
        quantity: "text-[20px] leading-5 font-medium text-[#3C404B]",
      },
    },
  },
}

export default hera
